import { createSelector } from "@reduxjs/toolkit";
import { SET_POINTED_DEVICE, SET_AVAILABLE_DEVICES, SET_ACTIVE_DEVICE } from "../actions/devicesActions";

export const getAvailableDevices = createSelector(
    state => state.deviceState,
    deviceState => deviceState.devices
);

export const anyAvailableDevice = createSelector(
    state => state.deviceState,
    deviceState => deviceState.devices && deviceState.devices.length > 0
);

export const getPointedDevice = createSelector(
    state => state.deviceState,
    deviceState => deviceState.pointedDevice
);

export const anyPointedDevice = createSelector(
    state => state.deviceState,
    deviceState => deviceState.pointedDevice !== undefined
)

export const getPointedDeviceId = createSelector(
    state => state.deviceState,
    deviceState => deviceState.pointedDevice && deviceState.pointedDevice.id
);

export const getActiveDevice = createSelector(
    state => state.deviceState,
    deviceState => deviceState.activeDevice
);

const INITIAL_STATE = {
    devices: [],
    pointedDevice: undefined,
    activeDevice: undefined
}

export const deviceState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_AVAILABLE_DEVICES:
            return {...state, devices: action.payload};
        case SET_POINTED_DEVICE:
            return {...state, pointedDevice: action.payload};
        case SET_ACTIVE_DEVICE:
            return {...state, activeDevice: action.payload};
        default:
            return state;
    }
}